(function () {
  const COLOR_PATTERN = /^(Skin|Brown)/i;
  const STYLE_ID = 'variant-gallery-filter-style';

  function getColor(alt) {
    if (!alt) return null;
    const m = alt.match(COLOR_PATTERN);
    return m ? m[1].toLowerCase() : null;
  }

  function getAlt(el) {
    const img = el.querySelector('img, [alt]');
    return img ? img.getAttribute('alt') || '' : '';
  }

  function reorderThumbs(thumbSlider) {
    const thumbList = thumbSlider.querySelector('ul') || thumbSlider;
    const all = Array.from(thumbList.querySelectorAll('li'));
    const visible = all.filter((s) => getComputedStyle(s).display !== 'none');
    const hidden = all.filter((s) => getComputedStyle(s).display === 'none');
    const scenes = visible.filter((s) => getAlt(s).toLowerCase().includes('scene'));
    const whites = visible.filter((s) => getAlt(s).toLowerCase().includes('white'));
    const others = visible.filter((s) => !scenes.includes(s) && !whites.includes(s));
    [...scenes, ...others, ...whites, ...hidden].forEach((s) => thumbList.appendChild(s));
  }

  function reinitSlider(slider) {
    if (!slider) return;
    const visibleItems = Array.from(slider.querySelectorAll('li')).filter(
      (li) => getComputedStyle(li).display !== 'none'
    );
    Object.defineProperty(slider, 'sliderItems', {
      get: () => visibleItems,
      configurable: true
    });
    if (typeof slider.initPages === 'function') slider.initPages();
    if (typeof slider.update === 'function') slider.update();
    delete slider.sliderItems;
  }

  function filterGallery(selectedColor) {
    if (!selectedColor) return;
    const color = String(selectedColor).trim().toLowerCase();
    const gallery = document.querySelector('[id^="GalleryViewer-"]');
    const thumbSlider = document.querySelector('[id^="GalleryThumbnails-"]');
    if (!gallery) return;

    const mainSlides = Array.from(gallery.querySelectorAll('li[data-media-id]'));
    const hasSelectedColorMedia = mainSlides.some((slide) => getColor(getAlt(slide)) === color);
    const visibleMainSlides = mainSlides.filter((slide) => {
      const c = getColor(getAlt(slide));
      return !c || c === color;
    });
    const shouldFilter = hasSelectedColorMedia && visibleMainSlides.length > 0;

    const hideSelectors = [];
    let firstSceneMediaId = null;

    if (shouldFilter) {
      mainSlides.forEach((slide) => {
        const alt = getAlt(slide);
        const c = getColor(alt);
        const mediaId = slide.dataset.mediaId;

        if (c && c !== color) {
          if (slide.id) hideSelectors.push(`li[id="${slide.id}"]`);
          else hideSelectors.push(`li[data-media-id="${mediaId}"]`);
        } else if (!firstSceneMediaId && alt.toLowerCase().includes('scene')) {
          firstSceneMediaId = mediaId;
        }
      });

      if (thumbSlider) {
        thumbSlider.querySelectorAll('li').forEach((thumb) => {
          const alt = getAlt(thumb);
          const c = getColor(alt);
          if (c && c !== color && thumb.id) {
            hideSelectors.push(`li[id="${thumb.id}"]`);
          }
        });
      }
    }

    let styleEl = document.getElementById(STYLE_ID);
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = STYLE_ID;
      document.head.appendChild(styleEl);
    }

    styleEl.textContent = hideSelectors.length
      ? `${hideSelectors.join(',')} { display: none !important; }`
      : '';

    setTimeout(() => {
      if (thumbSlider) reorderThumbs(thumbSlider);
      reinitSlider(gallery);
      reinitSlider(thumbSlider);

      if (shouldFilter && firstSceneMediaId) {
        document.querySelectorAll('[id^="MediaGallery-"]').forEach((mg) => {
          if (typeof mg.setActiveMedia === 'function') {
            mg.setActiveMedia(firstSceneMediaId, true);
          }
        });
      }
    }, 100);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const variantRadios = document.querySelector('variant-radios');
    if (!variantRadios) return;

    const defaultChecked = variantRadios.querySelector('.swatch-input__input:checked');
    if (defaultChecked) filterGallery(defaultChecked.value);

    variantRadios.addEventListener('change', function (e) {
      if (e.target.classList.contains('swatch-input__input')) {
        filterGallery(e.target.value);
      }
    });
  });
})();
